import { useState } from 'react'
import { BlockOutlined } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { GridActionsCellItem } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import LockOpenIcon from '@mui/icons-material/LockOpen'

import BlockDialog from 'components/Participants/ParticipantActions/Block/BlockDialog'
import UnblockDialog from 'components/Participants/ParticipantActions/Block/UnblockDialog'
import { Participant } from 'types/Participants'

type BlockProps = {
  participant: Participant
}

const BlockParticipant = ({ participant }: BlockProps) => {
  const { t } = useTranslation()
  const [isModalOpen, setModalVisibility] = useState(false)
  const [isUnblockModalVisible, setUnBlockModalVisibility] = useState(false)

  const label = t('participant.actions.block.label')

  const BlockButton = () => {
    if (participant.blocked) return <></>

    return (
      <Tooltip title={t('participant.actions.block.label')}>
        <span>
          <GridActionsCellItem
            key={label}
            icon={<BlockOutlined fontSize="small" />}
            label={label}
            onClick={() => setModalVisibility(true)}
            data-testid="block-participant"
          />
        </span>
      </Tooltip>
    )
  }

  const UnBlockButton = () => {
    if (!participant.blocked) return <></>
    const label = t('participant.actions.unblock.label')

    return (
      <Tooltip title={label}>
        <span>
          <GridActionsCellItem
            key={label}
            icon={<LockOpenIcon fontSize="small" />}
            label={label}
            onClick={() => setUnBlockModalVisibility(true)}
          />
        </span>
      </Tooltip>
    )
  }

  return (
    <>
      <BlockButton />
      <UnBlockButton />
      {!participant.blocked && (
        <BlockDialog
          participant={participant}
          isOpen={isModalOpen}
          setModalVisibility={setModalVisibility}
        />
      )}

      {participant.blocked && (
        <UnblockDialog
          participant={participant}
          isOpen={isUnblockModalVisible}
          setModalVisibility={setUnBlockModalVisibility}
        />
      )}
    </>
  )
}

export default BlockParticipant
